'use strict';

var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

styled__default["default"].button.withConfig({
  componentId: "sc-188ow23-0"
})(["height:", ";background:", ";color:", ";border-radius:", ";flex:none;order:0;flex-grow:0;border:0 none;margin:auto;align-self:center;justify-self:center;font-family:inherit;cursor:pointer;width:100%;@media (hover:hover){&:hover{background:", ";}}", ""], _ref => {
  var _theme$button, _theme$button$size;
  let {
    theme
  } = _ref;
  return `${((_theme$button = theme.button) === null || _theme$button === void 0 ? void 0 : (_theme$button$size = _theme$button.size) === null || _theme$button$size === void 0 ? void 0 : _theme$button$size.height) || 48}px`;
}, _ref2 => {
  var _theme$button2, _theme$button2$color, _theme$base;
  let {
    theme
  } = _ref2;
  return ((_theme$button2 = theme.button) === null || _theme$button2 === void 0 ? void 0 : (_theme$button2$color = _theme$button2.color) === null || _theme$button2$color === void 0 ? void 0 : _theme$button2$color.background) || ((_theme$base = theme.base) === null || _theme$base === void 0 ? void 0 : _theme$base.brandCallToAction);
}, _ref3 => {
  var _theme$button3;
  let {
    theme
  } = _ref3;
  return ((_theme$button3 = theme.button) === null || _theme$button3 === void 0 ? void 0 : _theme$button3.text) || '#FFF';
}, _ref4 => {
  var _theme$border, _theme$border$radius;
  let {
    theme
  } = _ref4;
  return `${((_theme$border = theme.border) === null || _theme$border === void 0 ? void 0 : (_theme$border$radius = _theme$border.radius) === null || _theme$border$radius === void 0 ? void 0 : _theme$border$radius.small) || 5}px`;
}, _ref5 => {
  var _theme$button4, _theme$button4$color, _theme$button5, _theme$button5$color, _theme$base2;
  let {
    theme
  } = _ref5;
  return ((_theme$button4 = theme.button) === null || _theme$button4 === void 0 ? void 0 : (_theme$button4$color = _theme$button4.color) === null || _theme$button4$color === void 0 ? void 0 : _theme$button4$color.hoverBackground) || ((_theme$button5 = theme.button) === null || _theme$button5 === void 0 ? void 0 : (_theme$button5$color = _theme$button5.color) === null || _theme$button5$color === void 0 ? void 0 : _theme$button5$color.background) || ((_theme$base2 = theme.base) === null || _theme$base2 === void 0 ? void 0 : _theme$base2.brandCallToAction);
}, props => props.disabled && styled.css(["background:", " !important;color:", ";cursor:default;@media (hover:hover){&:hover{background:", ";color:", ";}}"], _ref6 => {
  var _theme$button6, _theme$button6$color;
  let {
    theme
  } = _ref6;
  return ((_theme$button6 = theme.button) === null || _theme$button6 === void 0 ? void 0 : (_theme$button6$color = _theme$button6.color) === null || _theme$button6$color === void 0 ? void 0 : _theme$button6$color.disabledBackground) || '#999';
}, _ref7 => {
  var _theme$button7, _theme$button7$color;
  let {
    theme
  } = _ref7;
  return ((_theme$button7 = theme.button) === null || _theme$button7 === void 0 ? void 0 : (_theme$button7$color = _theme$button7.color) === null || _theme$button7$color === void 0 ? void 0 : _theme$button7$color.disabledText) || '#FFF';
}, _ref8 => {
  var _theme$button8, _theme$button8$color;
  let {
    theme
  } = _ref8;
  return ((_theme$button8 = theme.button) === null || _theme$button8 === void 0 ? void 0 : (_theme$button8$color = _theme$button8.color) === null || _theme$button8$color === void 0 ? void 0 : _theme$button8$color.disabledBackground) || '#999';
}, _ref9 => {
  var _theme$button9, _theme$button9$color;
  let {
    theme
  } = _ref9;
  return ((_theme$button9 = theme.button) === null || _theme$button9 === void 0 ? void 0 : (_theme$button9$color = _theme$button9.color) === null || _theme$button9$color === void 0 ? void 0 : _theme$button9$color.disabledText) || '#FFF';
}));
